import * as R from 'remeda';
import { apiUtility } from 'utility';
import { mutateAdd } from 'utility/domain';

import { NextCalculatedDto } from '../contracts';

function toInternalHourDomain(args: { dtos: NextCalculatedDto[] }) {
  const { dtos } = args;

  const internalHourDomain: NormalizedDomain<Data.InternalHour> = {
    allIds: [],
    byId: {},
  };

  apiUtility.iterator({
    list: dtos,
    transformer: (item) => {
      const {
        dayOfMonth,
        dayOfWeek,
        monthNumber,
        weekNumber,
        year,
        backlogItemCount,
        processedItemCount,
        receivedItemCount,
        subZoneId,
        hour,
        minute,
        zoneId,
      } = item;
      if (
        !R.isDefined(year) ||
        !R.isDefined(monthNumber) ||
        !R.isDefined(weekNumber) ||
        !R.isDefined(dayOfWeek) ||
        !R.isDefined(dayOfMonth) ||
        !R.isDefined(subZoneId)
      )
        throw 'A date field is missing in response';

      const internalHour: Data.InternalHour = {
        id: R.randomString(12),
        year,
        dayOfMonth,
        dayOfWeek,
        month: monthNumber - 1,
        week: weekNumber,
        subZoneId,
        zoneId,
        movingTotal: null,
        noBacklog: backlogItemCount,
        noProcessed: processedItemCount,
        noReceived: receivedItemCount,
        employeeId: null,
        hour,
        minute,
      };

      mutateAdd(internalHourDomain, internalHour);
    },
  });

  return { internalHourDomain };
}

export { toInternalHourDomain };
